import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/lib/site";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-stone-50 py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <SectionHeading
          overline="FAQ"
          title={
            <>
              Questions, <span className="italic bronze-text">answered</span>
            </>
          }
          align="center"
        />
        <Reveal delay={0.1} className="mt-14">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-stone-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-serif text-xl font-light text-stone-900 hover:text-brand-bronze-dark hover:no-underline sm:text-2xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base font-light leading-relaxed text-stone-600" data-testid={`faq-content-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
